import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

import { sanitizeBrowserQueryParams } from "@/utils/form/queryParams";

/**
 * Normalizes browser-visible query params after route/search changes.
 *
 * @returns {void}
 */
export const useBrowserQueryParamSanitizer = (): void => {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryString = searchParams.toString();

  useEffect(() => {
    const sanitizedParams = sanitizeBrowserQueryParams(searchParams);

    if (sanitizedParams.toString() === queryString) {
      return;
    }

    setSearchParams(sanitizedParams, { replace: true });
  }, [queryString, searchParams, setSearchParams]);
};
